module.exports = "mat-header-row.mat-header-row{display:none}\n"